"use client";

import { c as _c } from "react/compiler-runtime";
import { Input } from "@/components/rac/input";
import { type Country } from "@/info/countries";
import { isValidPhoneNumber } from "@/info/login";
import { type ChangeEvent, type KeyboardEvent } from "react";
import { Label } from "react-aria-components";
interface PhoneInputProps {
  phoneNumber: string;
  onPhoneNumberChange: (phone: string) => void;
  selectedCountry: Country;
  onEnterPress?: () => void;
  isDisabled?: boolean;
  placeholder?: string;
  hideError?: boolean;
  phoneVerified?: boolean;
  label?: string;
}
export function PhoneInput(t0) {
  const $ = _c(29);
  const {
    phoneNumber,
    onPhoneNumberChange,
    selectedCountry,
    onEnterPress,
    isDisabled: t1,
    placeholder: t2,
    hideError: t3,
    phoneVerified: t4,
    label: t5
  } = t0;
  const isDisabled = t1 === undefined ? false : t1;
  const placeholder = t2 === undefined ? "Enter your number" : t2;
  const hideError = t3 === undefined ? false : t3;
  const phoneVerified = t4 === undefined ? false : t4;
  const label = t5 === undefined ? "Phone Number" : t5;
  let t6;
  if ($[0] !== onPhoneNumberChange) {
    t6 = event => {
      const cleaned = event.target.value.replace(/[^\d]/g, "");
      onPhoneNumberChange(cleaned);
    };
    $[0] = onPhoneNumberChange;
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const handlePhoneChange = t6;
  let handleKeyDown;
  let isValid;
  if ($[2] !== onEnterPress || $[3] !== phoneNumber || $[4] !== selectedCountry) {
    handleKeyDown = event_0 => {
      if (event_0.key === "Enter" && onEnterPress && isValid && phoneNumber.length > 0) {
        event_0.preventDefault();
        onEnterPress();
      }
    };
    isValid = phoneNumber.length === 0 || isValidPhoneNumber(phoneNumber, selectedCountry.code);
    $[2] = onEnterPress;
    $[3] = phoneNumber;
    $[4] = selectedCountry;
    $[5] = handleKeyDown;
    $[6] = isValid;
  } else {
    handleKeyDown = $[5];
    isValid = $[6];
  }
  let t7;
  if ($[7] !== label) {
    t7 = <Label className="text-sm font-medium">{label}</Label>;
    $[7] = label;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const t8 = `w-full h-12 px-3 py-3 text-sm border rounded-lg transition-all duration-200 touch-manipulation ${isValid ? "border-gray-300" : "border-red-300"} ${isDisabled ? "opacity-50 cursor-not-allowed" : ""}`;
  let t9;
  if ($[9] !== handleKeyDown || $[10] !== handlePhoneChange || $[11] !== isDisabled || $[12] !== phoneNumber || $[13] !== placeholder || $[14] !== t8) {
    t9 = <Input type="tel" value={phoneNumber} onChange={handlePhoneChange} onKeyDown={handleKeyDown} placeholder={placeholder} className={t8} disabled={isDisabled} autoComplete="tel" inputMode="numeric" maxLength={10} />;
    $[9] = handleKeyDown;
    $[10] = handlePhoneChange;
    $[11] = isDisabled;
    $[12] = phoneNumber;
    $[13] = placeholder;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== phoneVerified) {
    t10 = phoneVerified && <span className="absolute right-3 top-1/2 -translate-y-1/2 bg-blue-600 text-white text-xs px-2 py-1 rounded">verified</span>;
    $[16] = phoneVerified;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = <div className="relative">{t9}{t10}</div>;
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== hideError || $[22] !== isValid || $[23] !== phoneNumber.length) {
    t12 = !hideError && !isValid && phoneNumber.length > 0 && <p className="text-xs text-red-600 mt-1">Please enter a valid phone number</p>;
    $[21] = hideError;
    $[22] = isValid;
    $[23] = phoneNumber.length;
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== t11 || $[26] !== t12 || $[27] !== t7) {
    t13 = <div className="space-y-2 mb-4">{t7}{t11}{t12}</div>;
    $[25] = t11;
    $[26] = t12;
    $[27] = t7;
    $[28] = t13;
  } else {
    t13 = $[28];
  }
  return t13;
}